import React, { Fragment } from "react";
import ReactECharts from "echarts-for-react";
import { useNavigate } from "react-router-dom";
import styles from "Components/Dashboard/dashboard.module.scss";
import { Spin } from "antd";
import { setFilter } from "Components/Topology/Device/deviceTableSlice";
import { getOption, ChartClick } from "../utils";
import { useStatistic } from "../../queries";
import { useAppSelector, useAppDispatch } from "store/hook";
import { Label, ChartContainer, DashCard } from "./Shared";
import { titleCase } from "Components/Topology/Device/utils";

// 預設的統計數據，當無法獲取數據時使用
const defaultStatistic = { health: { Good: 0, Warning: 0, Critical: 0, Offline: 0 } };

const PieHealth = React.memo(() => {
  // 使用 Redux Toolkit 中的 useAppSelector 獲取全局狀態
  const { loginCid, stateCid, level, isLogin } = useAppSelector((state) => state.global);
  // 使用 useStatistic 自定義 hook 從伺服器獲取設備統計數據
  const {
    data: deviceStatistic = defaultStatistic, // 如果沒有獲取到數據，使用預設值
    isLoading, // 用於初始數據的載入過程狀態
    isFetching, // 用於提供關於當前數據更新或重新讀取的即時反饋狀態
  } = useStatistic(level, stateCid, loginCid, isLogin);

  const health = deviceStatistic.health || [];

  /* 請求到 Health 並將物件中的values 用 reduce 函數 將物件內的value 進行加總
     health = {up: 1, warning: 0, critical: 0, offline: 18};  
     =>  Object.values(health).reduce((a, b) => a + b, 0) =>  1 + 0 + 0 + 18 + 0(預設值) = 19  */
  const HealthSum = Object.values(health).reduce((a, b) => a + b, 0);
  // 判斷是否正在載入數據
  const loading = isLoading || isFetching;
  const disp = useAppDispatch();
  const navigate = useNavigate();

  // 定義點擊圖表時的處理函數
  const onChartClick = (params: ChartClick, label: string) => {
    let selected = params?.data?.name?.toLowerCase();
    if (selected === "good" && selected) selected = "up";

    // 檢查選擇的值是否為 "good"，如果是，將其轉換為 "up"
    disp(setFilter({ health: [selected ?? (label === "good" ? "up" : label)] }));
    navigate("./overview"); // 導航到 "overview" 頁面
  };
  // 定義圖表點擊事件處理函數
  const onEvents = {
    click: onChartClick,
  };

  return (
    <DashCard title={"DevicesHealth"}>
      {loading ? (
        <Fragment>
          {/* 在載入中顯示旋轉的 Spin 組件 */}
          <Spin className={styles.loadingSpin} />
        </Fragment>
      ) : (
        <Fragment>
          {/* 顯示健康狀態標籤和圖表 */}
          <Label
            devicestatic={Object.entries(health).map(([key, value]) => [titleCase(key), value])}
            onChartClick={onChartClick}
            tooltip={["ISMS.Up", "ISMS.Warning", "ISMS.FatalError", "ISMS.Offline"]}
          />
          {HealthSum !== 0 && (
            <ChartContainer sum={HealthSum}>
              {/* 使用 ECharts 來渲染圓餅圖 */}
              <ReactECharts
                className={styles.pie__chart}
                option={getOption(Object.entries(health))}
                notMerge={true}
                lazyUpdate={true}
                theme={"theme_name"}
                onEvents={onEvents}
              />
            </ChartContainer>
          )}
        </Fragment>
      )}
    </DashCard>
  );
});

export default PieHealth;
